var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jobs_wrapper" }, [
    _c("div", { class: { overlay_setting: _vm.isLoadingData } }, [
      _c("i", { class: { loadding_setting: _vm.isLoadingData } })
    ]),
    !_vm.isLoadingData
      ? _c("div", [
          !_vm.isSearched
            ? _c("div", [
                _vm.jobSearchPageName
                  ? _c(
                      "h1",
                      {
                        staticClass:
                          "jobs_page_title_preview setting_word_break",
                        style: { color: _vm.colorSetting.pageText }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.jobSearchPageName) +
                            "\n      "
                        )
                      ]
                    )
                  : _c(
                      "h1",
                      {
                        staticClass: "jobs_page_title",
                        style: { color: _vm.colorSetting.pageText }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.labelProperties.JOB_PAGE_TITLE) +
                            "\n      "
                        )
                      ]
                    ),
                _vm.jobSearchPageOverview
                  ? _c(
                      "p",
                      {
                        staticClass:
                          "jobs_table_annotation_preview setting_word_break"
                      },
                      [_vm._v(_vm._s(_vm.jobSearchPageOverview))]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "jobs_table_wrapper" },
                  [
                    _vm._l(_vm.categoriesJobSearch, function(category, cIndex) {
                      return [
                        category &&
                        !category.categoryDeleted &&
                        !_vm.isEmptyCategoryInJobSearch(cIndex)
                          ? [
                              _c(
                                "h2",
                                {
                                  staticClass: "jobs_category_title mt-3",
                                  style: {
                                    color: _vm.colorSetting.pageText,
                                    borderLeftColor: _vm.colorSetting.keyColor
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(category.categoryName) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._l(category.item, function(item, index) {
                                return [
                                  _c(
                                    "table",
                                    {
                                      staticClass: "jobs_table",
                                      style: {
                                        backgroundColor:
                                          _vm.colorSetting.pageBackground
                                      }
                                    },
                                    [
                                      _c(
                                        "tbody",
                                        { staticClass: "jobs_table_body" },
                                        _vm._l(
                                          _vm.filterResourceField(
                                            item.resourceField
                                          ),
                                          function(subItem, indexItem) {
                                            return _c(
                                              "tr",
                                              {
                                                key: indexItem,
                                                staticClass: "jobs_table_rows"
                                              },
                                              [
                                                _c(
                                                  "th",
                                                  {
                                                    staticClass:
                                                      "jobs_table_head",
                                                    style: [
                                                      {
                                                        backgroundColor:
                                                          _vm.colorSetting
                                                            .subColor
                                                      },
                                                      index === 0
                                                        ? {
                                                            border:
                                                              "1px solid" +
                                                              _vm.colorSetting
                                                                .borderColor
                                                          }
                                                        : {
                                                            borderLeft:
                                                              "1px solid" +
                                                              _vm.colorSetting
                                                                .borderColor,
                                                            borderRight:
                                                              "1px solid" +
                                                              _vm.colorSetting
                                                                .borderColor,
                                                            borderBottom:
                                                              "1px solid" +
                                                              _vm.colorSetting
                                                                .borderColor
                                                          }
                                                    ]
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "jobs_table_head_holder"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "jobs_table_label",
                                                            style: {
                                                              color:
                                                                _vm.colorSetting
                                                                  .pageText
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  item.itemName
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "jobs_table_cell",
                                                    style: [
                                                      index === 0
                                                        ? {
                                                            border:
                                                              "1px solid" +
                                                              _vm.colorSetting
                                                                .borderColor
                                                          }
                                                        : {
                                                            borderLeft:
                                                              "1px solid" +
                                                              _vm.colorSetting
                                                                .borderColor,
                                                            borderRight:
                                                              "1px solid" +
                                                              _vm.colorSetting
                                                                .borderColor,
                                                            borderBottom:
                                                              "1px solid" +
                                                              _vm.colorSetting
                                                                .borderColor
                                                          }
                                                    ]
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "jobs_table_form_rows"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "jobs_table_form_item"
                                                          },
                                                          [
                                                            _c(
                                                              "InputComponent",
                                                              {
                                                                staticClass:
                                                                  "mt-3",
                                                                attrs: {
                                                                  resource: subItem,
                                                                  indexResource: indexItem,
                                                                  master: _vm.getMasterData(
                                                                    subItem.master_name
                                                                  ),
                                                                  draftColors:
                                                                    _vm.colorSetting,
                                                                  itemJob: true,
                                                                  itemName:
                                                                    item.itemName
                                                                }
                                                              }
                                                            ),
                                                            item.viewAnnotation &&
                                                            item.annotationText
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "setting_word_break"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        style: {
                                                                          color:
                                                                            _vm
                                                                              .colorSetting
                                                                              .pageText
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                              ※" +
                                                                            _vm._s(
                                                                              item.annotationText
                                                                            ) +
                                                                            "\n                            "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ]
                                  )
                                ]
                              })
                            ]
                          : _vm._e()
                      ]
                    }),
                    _c(
                      "h2",
                      {
                        staticClass: "jobs_category_title mt-3",
                        style: {
                          color: _vm.colorSetting.pageText,
                          borderLeftColor: _vm.colorSetting.keyColor
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.labelProperties.CATEGORY_FREE_WORD) +
                            "\n        "
                        )
                      ]
                    ),
                    _c("table", { staticClass: "jobs_table" }, [
                      _c("tbody", { staticClass: "jobs_table_body" }, [
                        _c("tr", { staticClass: "jobs_table_rows" }, [
                          _c(
                            "th",
                            {
                              staticClass: "jobs_table_head",
                              style: {
                                borderTop:
                                  "1px solid" + _vm.colorSetting.borderColor,
                                borderLeft:
                                  "1px solid" + _vm.colorSetting.borderColor,
                                borderBottom:
                                  "1px solid" + _vm.colorSetting.borderColor,
                                backgroundColor: _vm.colorSetting.subColor
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "jobs_table_head_holder" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "jobs_table_label",
                                      style: {
                                        color: _vm.colorSetting.pageText
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.labelProperties.FREE_WORD_SEARCH
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "jobs_table_cell",
                              style: {
                                borderTop:
                                  "1px solid" + _vm.colorSetting.borderColor,
                                borderLeft:
                                  "1px solid" + _vm.colorSetting.borderColor,
                                borderRight:
                                  "1px solid" + _vm.colorSetting.borderColor,
                                borderBottom:
                                  "1px solid" + _vm.colorSetting.borderColor
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "jobs_table_form_rows" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "jobs_table_form_item mt-3"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.freeWord,
                                            expression: "freeWord"
                                          }
                                        ],
                                        staticClass: "jobs_form_text",
                                        attrs: {
                                          type: "text",
                                          placeholder:
                                            _vm.labelProperties
                                              .PLACE_HOLDER_WORD_SEARCH
                                        },
                                        domProps: { value: _vm.freeWord },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.freeWord = $event.target.value
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "jobs_table_form_rows" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "jobs_table_form_item" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "jobs_table_form_label_box"
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "setting_form_radio_label"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.condition,
                                                    expression: "condition"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "radio",
                                                  id: "and",
                                                  value: "and"
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.condition,
                                                    "and"
                                                  )
                                                },
                                                on: {
                                                  change: function($event) {
                                                    _vm.condition = "and"
                                                  }
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "setting_form_radio_text",
                                                  style: {
                                                    color:
                                                      _vm.colorSetting.pageText
                                                  },
                                                  attrs: { for: "and" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        _vm.labelProperties.AND
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "setting_form_radio_label"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.condition,
                                                    expression: "condition"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "radio",
                                                  id: "or",
                                                  value: "or"
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.condition,
                                                    "or"
                                                  )
                                                },
                                                on: {
                                                  change: function($event) {
                                                    _vm.condition = "or"
                                                  }
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "setting_form_radio_text",
                                                  style: {
                                                    color:
                                                      _vm.colorSetting.pageText
                                                  },
                                                  attrs: { for: "or" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        _vm.labelProperties.OR
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "ml-3 jobs_table_annotation",
                                              style: {
                                                color: _vm.colorSetting.pageText
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.labelProperties
                                                      .NOTICE_FREE_WORD
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "jobs_annotation_box" }, [
                      _c("p", { staticClass: "jobs_annotation_text" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.labelProperties.NOTICE_CANT_SEARCH_COMBINATION
                            ) +
                            "\n          "
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "jobs_btn_box" }, [
                      _c(
                        "button",
                        {
                          staticClass: "jobs_btn_primary mt-5",
                          style: {
                            color: _vm.colorSetting.mainButtonText,
                            backgroundColor: _vm.colorSetting.mainButton,
                            border: "1px solid" + _vm.colorSetting.borderColor
                          },
                          on: { click: _vm.searchJobDetail }
                        },
                        [
                          _vm.button.searchBtn === ""
                            ? _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.labelProperties.CONFIRM_BUTTON) +
                                    "\n            "
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.button.searchBtn) +
                                    "\n            "
                                )
                              ])
                        ]
                      )
                    ])
                  ],
                  2
                )
              ])
            : _c("div", [
                _c("h1", { staticClass: "jobs_page_title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.searchJobLabelsProperty.SEARCH_RESULT_LIST) +
                      "\n      "
                  )
                ]),
                _c("h2", { staticClass: "jobs_category_title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.searchJobLabelsProperty.CURRENT_SEARCH_CRITERIA
                      ) +
                      "\n      "
                  )
                ]),
                _c("div", { class: { overlay_setting: _vm.isLoadingData } }, [
                  _c("i", { class: { loadding_setting: _vm.isLoadingData } })
                ]),
                _c("div", { staticClass: "jobs_search_condition" }, [
                  _c(
                    "div",
                    { staticClass: "jobs_search_condition_inner" },
                    [
                      !_vm.freeWord
                        ? [
                            _vm._l(_vm.categoriesJobSearch, function(category) {
                              return [
                                _c(
                                  "dl",
                                  { staticClass: "jobs_search_condition_list" },
                                  [
                                    _vm._l(category.item, function(item) {
                                      return [
                                        !item.resourceField[0]
                                          .isDeletedByMainSystem &&
                                        item.resourceField[0].isHasValue
                                          ? [
                                              _c(
                                                "dt",
                                                {
                                                  staticClass:
                                                    "jobs_search_condition_label setting_word_break"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item.itemName) +
                                                      "\n                      "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "dd",
                                                {
                                                  staticClass:
                                                    "jobs_search_condition_desc setting_word_break"
                                                },
                                                [
                                                  (item.resourceField[0]
                                                    .default_value &&
                                                    (item.resourceField[0]
                                                      .type === "text" ||
                                                      item.resourceField[0]
                                                        .type === "textarea" ||
                                                      item.resourceField[0]
                                                        .type === "url" ||
                                                      item.resourceField[0].type.includes(
                                                        "email"
                                                      ))) ||
                                                  item.resourceField[0].type ===
                                                    "tel" ||
                                                  item.resourceField[0].type ===
                                                    "sequence"
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              item
                                                                .resourceField[0]
                                                                .default_value
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ])
                                                    : item.resourceField[0]
                                                        .default_value &&
                                                      _vm.TYPE_OF_MULTI_SELECT.includes(
                                                        item.resourceField[0]
                                                          .type
                                                      ) &&
                                                      item.resourceField[0]
                                                        .default_value.length >
                                                        0
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.getValueCheckBox(
                                                                item
                                                                  .resourceField[0]
                                                                  .default_value
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ])
                                                    : item.resourceField[0]
                                                        .default_value !==
                                                        null &&
                                                      _vm.TYPE_OF_SINGLE_SELECT.includes(
                                                        item.resourceField[0]
                                                          .type
                                                      )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.getSingleSelect(
                                                                item
                                                                  .resourceField[0]
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ])
                                                    : _vm.FORMAT_DATE.includes(
                                                        item.resourceField[0]
                                                          .type
                                                      )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.getDatetimeString(
                                                                item
                                                                  .resourceField[0]
                                                                  .type,
                                                                item
                                                                  .resourceField[0]
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ])
                                                    : !_vm.TYPE_OF_NUMBER.includes(
                                                        item.resourceField[0]
                                                          .type
                                                      ) &&
                                                      (item.resourceField[0]
                                                        .default_value_from ||
                                                        item.resourceField[0]
                                                          .default_value_to)
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              item
                                                                .resourceField[0]
                                                                .default_value_from
                                                            ) +
                                                            " ~ " +
                                                            _vm._s(
                                                              item
                                                                .resourceField[0]
                                                                .default_value_to
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ])
                                                    : _vm.TYPE_OF_NUMBER.includes(
                                                        item.resourceField[0]
                                                          .type
                                                      ) &&
                                                      (item.resourceField[0]
                                                        .default_value_from ||
                                                        item.resourceField[0]
                                                          .default_value_to)
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.formatNumberByStep(
                                                                item
                                                                  .resourceField[0]
                                                                  .default_value_from,
                                                                item
                                                                  .resourceField[0]
                                                                  .step
                                                              )
                                                            ) +
                                                            " ~\n                        " +
                                                            _vm._s(
                                                              _vm.formatNumberByStep(
                                                                item
                                                                  .resourceField[0]
                                                                  .default_value_to,
                                                                item
                                                                  .resourceField[0]
                                                                  .step
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(" -- ")
                                                      ]),
                                                  item.resourceField[0].unit
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "ml-1",
                                                          class: {
                                                            label_unit_item_long:
                                                              item
                                                                .resourceField[0]
                                                                .unit.length >
                                                              _vm.userConfig
                                                                .UNIT_LENGTH,
                                                            label_unit_item:
                                                              item
                                                                .resourceField[0]
                                                                .unit.length <=
                                                              _vm.userConfig
                                                                .UNIT_LENGTH
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item
                                                                .resourceField[0]
                                                                .unit
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ]
                                    })
                                  ],
                                  2
                                )
                              ]
                            })
                          ]
                        : _vm._e(),
                      _vm.freeWord
                        ? _c("div", { staticClass: "jobs_search_setting" }, [
                            _c(
                              "dt",
                              {
                                staticClass:
                                  "jobs_search_condition_label setting_word_break"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.searchJobLabelsProperty.FREE_WORD
                                    ) +
                                    "（\n              "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "text-transform": "uppercase"
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.condition) + " ")]
                                ),
                                _vm._v(")\n            ")
                              ]
                            ),
                            _c(
                              "dd",
                              {
                                staticClass:
                                  "jobs_search_condition_desc setting_word_break"
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.freeWord) +
                                      "\n              "
                                  )
                                ])
                              ]
                            )
                          ])
                        : _vm._e(),
                      !_vm.numberOfSearchByItem && !_vm.freeWord
                        ? [
                            _c("label", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.searchJobLabelsProperty.NONE) +
                                  "\n            "
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c("div", { staticClass: "jobs_search_condition_btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "jobs_btn_secondary jobs_btn_medium",
                        style: {
                          color: _vm.colorSetting.subButtonText,
                          backgroundColor: _vm.colorSetting.subButton
                        },
                        on: { click: _vm.returnJobSearchPage }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.searchJobLabelsProperty
                                .BUTTON_CHANGE_CONDITON_SEARCH
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ]),
                _vm.totalResultSearchJob > 0
                  ? _c("div", { staticClass: "jobs_search_result" }, [
                      _c("span", { staticClass: "jobs_search_result_number" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.totalResultSearchJob) +
                            "\n        "
                        )
                      ]),
                      _c("span", { staticClass: "jobs_search_result_unit" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.searchJobLabelsProperty.IN_PIECE) +
                            "\n        "
                        )
                      ]),
                      _c("span", { staticClass: "jobs_search_result_range" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.fromJob) +
                            " ～ " +
                            _vm._s(
                              _vm.totalResultSearchJob > _vm.toJob
                                ? _vm.toJob
                                : _vm.totalResultSearchJob
                            ) +
                            " " +
                            _vm._s(_vm.searchJobLabelsProperty.SHOW_MATTER) +
                            "\n        "
                        )
                      ])
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "jobs_result" },
                  _vm._l(_vm.jobViewDetails, function(job, indexJobDetail) {
                    return _c(
                      "ul",
                      { key: indexJobDetail, staticClass: "jobs_result_list" },
                      [
                        !job.flag
                          ? _c("li", { staticClass: "jobs_result_item" }, [
                              _c(
                                "div",
                                { staticClass: "jobs_result_inner" },
                                [
                                  _c(
                                    "h2",
                                    { staticClass: "jobs_result_heading" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            target: _vm.jobNewWindow
                                              ? "_blank"
                                              : "",
                                            to:
                                              "/?c=" +
                                              encodeURIComponent(
                                                _vm.encryptJobCode
                                              ) +
                                              "&jid=" +
                                              job.id +
                                              "&query=" +
                                              encodeURIComponent(
                                                _vm.keyRedisSearch
                                              ) +
                                              "&jt=" +
                                              _vm.DETAIL_FORM_TYPE
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              !_vm.jobNewWindow
                                                ? _vm.onTopOfIframe()
                                                : null
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "jobs_result_title",
                                              staticStyle: {
                                                "text-decoration": "none"
                                              },
                                              style: {
                                                color: _vm.colorSetting.linkText
                                              }
                                            },
                                            [
                                              _vm._l(
                                                _vm.headingSettings,
                                                function(
                                                  headingSetting,
                                                  index
                                                ) {
                                                  return [
                                                    job[headingSetting.name] &&
                                                    _vm.jobResourceFields[
                                                      headingSetting.name
                                                    ]
                                                      ? [
                                                          _vm.isPreviousItemHaveData(
                                                            job,
                                                            headingSetting.name,
                                                            index,
                                                            _vm.headingSettings[
                                                              index
                                                                ? index - 1
                                                                : index
                                                            ].name,
                                                            _vm.headingSettings
                                                          )
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "\n                          /\n                        "
                                                                )
                                                              ])
                                                            : _vm._e(),
                                                          _vm.jobResourceFields[
                                                            headingSetting.name
                                                          ].name ===
                                                          "company_id"
                                                            ? _c("span", [
                                                                job[
                                                                  _vm
                                                                    .companyPublicSetting
                                                                ] === 1
                                                                  ? _c("span", [
                                                                      _vm.getCompanyNameByCompanyId(
                                                                        job.company_id
                                                                      )
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                              " +
                                                                                  _vm._s(
                                                                                    _vm.getCompanyNameByCompanyId(
                                                                                      job.company_id
                                                                                    )
                                                                                  ) +
                                                                                  "\n                            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                              " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .searchJobLabelsProperty
                                                                                      .NAME_COMPANY_UNREGISTER
                                                                                  ) +
                                                                                  "\n                            "
                                                                              )
                                                                            ]
                                                                          )
                                                                    ])
                                                                  : _c("span", [
                                                                      _vm._v(
                                                                        "\n                            " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .searchJobLabelsProperty
                                                                              .NAME_COMPANY_PRIVATE
                                                                          ) +
                                                                          "\n                          "
                                                                      )
                                                                    ])
                                                              ])
                                                            : _vm
                                                                .jobResourceFields[
                                                                headingSetting
                                                                  .name
                                                              ].name ===
                                                              "staff_id"
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.getStaffNameByStaffId(
                                                                        job.staff_id
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ])
                                                            : _vm
                                                                .jobResourceFields[
                                                                headingSetting
                                                                  .name
                                                              ].type ===
                                                                "free_email" &&
                                                              job[
                                                                headingSetting
                                                                  .name
                                                              ].data
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      job[
                                                                        headingSetting
                                                                          .name
                                                                      ].data
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ])
                                                            : _vm
                                                                .jobResourceFields[
                                                                headingSetting
                                                                  .name
                                                              ].type === "url"
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      job[
                                                                        headingSetting
                                                                          .name
                                                                      ]
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ])
                                                            : _vm.TYPE_OF_SINGLE_SELECT.includes(
                                                                _vm
                                                                  .jobResourceFields[
                                                                  headingSetting
                                                                    .name
                                                                ].type
                                                              ) &&
                                                              _vm
                                                                .jobResourceFields[
                                                                headingSetting
                                                                  .name
                                                              ].master_name &&
                                                              _vm
                                                                .jobResourceFields[
                                                                headingSetting
                                                                  .name
                                                              ].name
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.getSingleSelectValue(
                                                                        _vm
                                                                          .jobResourceFields[
                                                                          headingSetting
                                                                            .name
                                                                        ]
                                                                          .master_name,
                                                                        job[
                                                                          headingSetting
                                                                            .name
                                                                        ]
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ])
                                                            : _vm.TYPE_OF_MULTI_SELECT.includes(
                                                                _vm
                                                                  .jobResourceFields[
                                                                  headingSetting
                                                                    .name
                                                                ].type
                                                              ) &&
                                                              _vm
                                                                .jobResourceFields[
                                                                headingSetting
                                                                  .name
                                                              ].master_name &&
                                                              _vm
                                                                .jobResourceFields[
                                                                headingSetting
                                                                  .name
                                                              ].name
                                                            ? _c(
                                                                "span",
                                                                _vm._l(
                                                                  _vm.getMultiSelectValue(
                                                                    _vm
                                                                      .jobResourceFields[
                                                                      headingSetting
                                                                        .name
                                                                    ]
                                                                      .master_name,
                                                                    job[
                                                                      headingSetting
                                                                        .name
                                                                    ]
                                                                  ),
                                                                  function(
                                                                    value,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      {
                                                                        key: index
                                                                      },
                                                                      [
                                                                        index !==
                                                                        0
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  ", "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                value
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              )
                                                            : _vm.FORMAT_DATE.includes(
                                                                _vm
                                                                  .jobResourceFields[
                                                                  headingSetting
                                                                    .name
                                                                ].type
                                                              )
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.getDatetimeString(
                                                                        _vm
                                                                          .jobResourceFields[
                                                                          headingSetting
                                                                            .name
                                                                        ].type,
                                                                        job[
                                                                          headingSetting
                                                                            .name
                                                                        ]
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ])
                                                            : _vm.TYPE_OF_NUMBER.includes(
                                                                _vm
                                                                  .jobResourceFields[
                                                                  headingSetting
                                                                    .name
                                                                ].type
                                                              )
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.formatNumberByStep(
                                                                        job[
                                                                          headingSetting
                                                                            .name
                                                                        ],
                                                                        _vm
                                                                          .jobResourceFields[
                                                                          headingSetting
                                                                            .name
                                                                        ].step
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ])
                                                            : _c("span", [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      job[
                                                                        headingSetting
                                                                          .name
                                                                      ]
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ]),
                                                          _vm.jobResourceFields[
                                                            headingSetting.name
                                                          ].unit
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "ml-1",
                                                                  class: {
                                                                    label_unit_item_long:
                                                                      _vm
                                                                        .jobResourceFields[
                                                                        headingSetting
                                                                          .name
                                                                      ].unit
                                                                        .length >
                                                                      _vm
                                                                        .userConfig
                                                                        .UNIT_LENGTH,
                                                                    label_unit_item:
                                                                      _vm
                                                                        .jobResourceFields[
                                                                        headingSetting
                                                                          .name
                                                                      ].unit
                                                                        .length <=
                                                                      _vm
                                                                        .userConfig
                                                                        .UNIT_LENGTH
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .jobResourceFields[
                                                                        headingSetting
                                                                          .name
                                                                      ].unit
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      : _vm._e()
                                                  ]
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._l(_vm.bodySettings, function(
                                    bodySetting,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "jobs_result_text"
                                      },
                                      [
                                        job[bodySetting.name] &&
                                        _vm.jobResourceFields[bodySetting.name]
                                          ? [
                                              _vm.jobResourceFields[
                                                bodySetting.name
                                              ].name === "company_id"
                                                ? _c("span", [
                                                    job[
                                                      _vm.companyPublicSetting
                                                    ] === 1
                                                      ? _c("span", [
                                                          _vm.getCompanyNameByCompanyId(
                                                            job.company_id
                                                          )
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      _vm.getCompanyNameByCompanyId(
                                                                        job.company_id
                                                                      )
                                                                    ) +
                                                                    "\n                      "
                                                                )
                                                              ])
                                                            : _c("span", [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .searchJobLabelsProperty
                                                                        .NAME_COMPANY_UNREGISTER
                                                                    ) +
                                                                    "\n                      "
                                                                )
                                                              ])
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm
                                                                  .searchJobLabelsProperty
                                                                  .NAME_COMPANY_PRIVATE
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ])
                                                  ])
                                                : _vm.jobResourceFields[
                                                    bodySetting.name
                                                  ].name === "staff_id"
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.getStaffNameByStaffId(
                                                            job.staff_id
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ])
                                                : _vm.jobResourceFields[
                                                    bodySetting.name
                                                  ].type === "free_email" &&
                                                  job[bodySetting.name].data
                                                ? _c("span", [
                                                    _c(
                                                      "a",
                                                      {
                                                        style: {
                                                          color:
                                                            _vm.colorSetting
                                                              .linkText
                                                        },
                                                        attrs: {
                                                          href:
                                                            "mailto:" +
                                                            job[
                                                              bodySetting.name
                                                            ].data
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              job[
                                                                bodySetting.name
                                                              ].data
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm.jobResourceFields[
                                                    bodySetting.name
                                                  ].type === "url"
                                                ? _c("span", [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticStyle: {
                                                          "text-decoration":
                                                            "none"
                                                        },
                                                        style: {
                                                          color:
                                                            _vm.colorSetting
                                                              .linkText
                                                        },
                                                        attrs: {
                                                          href:
                                                            job[
                                                              bodySetting.name
                                                            ],
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              job[
                                                                bodySetting.name
                                                              ]
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm.TYPE_OF_SINGLE_SELECT.includes(
                                                    _vm.jobResourceFields[
                                                      bodySetting.name
                                                    ].type
                                                  ) &&
                                                  _vm.jobResourceFields[
                                                    bodySetting.name
                                                  ].master_name &&
                                                  _vm.jobResourceFields[
                                                    bodySetting.name
                                                  ].name
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.getSingleSelectValue(
                                                            _vm
                                                              .jobResourceFields[
                                                              bodySetting.name
                                                            ].master_name,
                                                            job[
                                                              bodySetting.name
                                                            ]
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ])
                                                : _vm.TYPE_OF_MULTI_SELECT.includes(
                                                    _vm.jobResourceFields[
                                                      bodySetting.name
                                                    ].type
                                                  ) &&
                                                  _vm.jobResourceFields[
                                                    bodySetting.name
                                                  ].master_name &&
                                                  _vm.jobResourceFields[
                                                    bodySetting.name
                                                  ].name
                                                ? _c(
                                                    "span",
                                                    _vm._l(
                                                      _vm.getMultiSelectValue(
                                                        _vm.jobResourceFields[
                                                          bodySetting.name
                                                        ].master_name,
                                                        job[bodySetting.name]
                                                      ),
                                                      function(value, index) {
                                                        return _c(
                                                          "span",
                                                          { key: index },
                                                          [
                                                            index !== 0
                                                              ? _c("span", [
                                                                  _vm._v(", ")
                                                                ])
                                                              : _vm._e(),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(value)
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm.FORMAT_DATE.includes(
                                                    _vm.jobResourceFields[
                                                      bodySetting.name
                                                    ].type
                                                  )
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.getDatetimeString(
                                                            _vm
                                                              .jobResourceFields[
                                                              bodySetting.name
                                                            ].type,
                                                            job[
                                                              bodySetting.name
                                                            ]
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ])
                                                : _vm.TYPE_OF_NUMBER.includes(
                                                    _vm.jobResourceFields[
                                                      bodySetting.name
                                                    ].type
                                                  )
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.formatNumberByStep(
                                                            job[
                                                              bodySetting.name
                                                            ],
                                                            _vm
                                                              .jobResourceFields[
                                                              bodySetting.name
                                                            ].step
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ])
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pre-margin-bottom line_break_setting_text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          job[bodySetting.name]
                                                        )
                                                      )
                                                    ]
                                                  ),
                                              _vm.jobResourceFields[
                                                bodySetting.name
                                              ].unit
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "ml-1",
                                                      class: {
                                                        label_unit_item_long:
                                                          _vm.jobResourceFields[
                                                            bodySetting.name
                                                          ].unit.length >
                                                          _vm.userConfig
                                                            .UNIT_LENGTH,
                                                        label_unit_item:
                                                          _vm.jobResourceFields[
                                                            bodySetting.name
                                                          ].unit.length <=
                                                          _vm.userConfig
                                                            .UNIT_LENGTH
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.jobResourceFields[
                                                            bodySetting.name
                                                          ].unit
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  }),
                                  _vm._l(_vm.categoriesJobList, function(
                                    category,
                                    cIndex
                                  ) {
                                    return [
                                      category &&
                                      !category.categoryDeleted &&
                                      !_vm.isEmptyCategory(
                                        cIndex,
                                        indexJobDetail,
                                        job.flag
                                      )
                                        ? [
                                            _c(
                                              "h2",
                                              {
                                                staticClass:
                                                  "jobs_category_title mt-3",
                                                style: {
                                                  color:
                                                    _vm.colorSetting.pageText,
                                                  borderLeftColor:
                                                    _vm.colorSetting.keyColor
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      category.categoryName
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "table",
                                              {
                                                staticClass: "jobs_detail_table"
                                              },
                                              [
                                                _c(
                                                  "tbody",
                                                  {
                                                    staticClass:
                                                      "jobs_detail_table_body"
                                                  },
                                                  [
                                                    _vm._l(
                                                      category.item.filter(
                                                        function(item) {
                                                          return !item
                                                            .resourceField[0]
                                                            .isDeletedByMainSystem
                                                        }
                                                      ),
                                                      function(item, index) {
                                                        return [
                                                          !item.resourceField[0].name.startsWith(
                                                            _vm
                                                              .jobSettingProperty
                                                              .ITEM_COMPANY_MODIFY
                                                          ) &&
                                                          job[
                                                            item
                                                              .resourceField[0]
                                                              .name
                                                          ] &&
                                                          ((item
                                                            .resourceField[0]
                                                            .name ===
                                                            "company_id" &&
                                                            job[
                                                              _vm
                                                                .companyPublicSetting
                                                            ] === 1 &&
                                                            _vm.getCompanyNameByCompanyId(
                                                              job.company_id
                                                            )) ||
                                                            item
                                                              .resourceField[0]
                                                              .name !==
                                                              "company_id")
                                                            ? _c(
                                                                "tr",
                                                                {
                                                                  key:
                                                                    item
                                                                      .resourceField[0]
                                                                      .name,
                                                                  staticClass:
                                                                    "jobs_detail_table_rows"
                                                                },
                                                                [
                                                                  _c(
                                                                    "th",
                                                                    {
                                                                      staticClass:
                                                                        "jobs_detail_table_head",
                                                                      style: [
                                                                        {
                                                                          backgroundColor:
                                                                            _vm
                                                                              .colorSetting
                                                                              .subColor
                                                                        },
                                                                        index ===
                                                                        0
                                                                          ? {
                                                                              border:
                                                                                "1px solid" +
                                                                                _vm
                                                                                  .colorSetting
                                                                                  .borderColor
                                                                            }
                                                                          : {
                                                                              borderLeft:
                                                                                "1px solid" +
                                                                                _vm
                                                                                  .colorSetting
                                                                                  .borderColor,
                                                                              borderRight:
                                                                                "1px solid" +
                                                                                _vm
                                                                                  .colorSetting
                                                                                  .borderColor,
                                                                              borderBottom:
                                                                                "1px solid" +
                                                                                _vm
                                                                                  .colorSetting
                                                                                  .borderColor
                                                                            }
                                                                      ]
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "setting_word_break",
                                                                          style: {
                                                                            color:
                                                                              _vm
                                                                                .colorSetting
                                                                                .pageText
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                              " +
                                                                              _vm._s(
                                                                                item.itemName
                                                                              ) +
                                                                              "\n                            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "td",
                                                                    {
                                                                      staticClass:
                                                                        "jobs_detail_table_cell word-break",
                                                                      style: {
                                                                        borderTop:
                                                                          "1px solid" +
                                                                          _vm
                                                                            .colorSetting
                                                                            .borderColor,
                                                                        borderRight:
                                                                          "1px solid" +
                                                                          _vm
                                                                            .colorSetting
                                                                            .borderColor,
                                                                        borderBottom:
                                                                          "1px solid" +
                                                                          _vm
                                                                            .colorSetting
                                                                            .borderColor
                                                                      }
                                                                    },
                                                                    [
                                                                      item
                                                                        .resourceField[0]
                                                                        .name ===
                                                                      "company_id"
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                              " +
                                                                                  _vm._s(
                                                                                    _vm.getCompanyNameByCompanyId(
                                                                                      job.company_id
                                                                                    )
                                                                                  ) +
                                                                                  "\n                            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : item
                                                                            .resourceField[0]
                                                                            .type ===
                                                                            "free_email" &&
                                                                          job[
                                                                            item
                                                                              .resourceField[0]
                                                                              .name
                                                                          ].data
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  style: {
                                                                                    color:
                                                                                      _vm
                                                                                        .colorSetting
                                                                                        .linkText
                                                                                  },
                                                                                  attrs: {
                                                                                    href:
                                                                                      "mailto:" +
                                                                                      job[
                                                                                        item
                                                                                          .resourceField[0]
                                                                                          .name
                                                                                      ]
                                                                                        .data
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                " +
                                                                                      _vm._s(
                                                                                        job[
                                                                                          item
                                                                                            .resourceField[0]
                                                                                            .name
                                                                                        ]
                                                                                          .data
                                                                                      ) +
                                                                                      "\n                              "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        : item
                                                                            .resourceField[0]
                                                                            .type ===
                                                                          "url"
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  style: {
                                                                                    color:
                                                                                      _vm
                                                                                        .colorSetting
                                                                                        .linkText
                                                                                  },
                                                                                  attrs: {
                                                                                    href:
                                                                                      job[
                                                                                        item
                                                                                          .resourceField[0]
                                                                                          .name
                                                                                      ],
                                                                                    target:
                                                                                      "_blank"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                " +
                                                                                      _vm._s(
                                                                                        job[
                                                                                          item
                                                                                            .resourceField[0]
                                                                                            .name
                                                                                        ]
                                                                                      ) +
                                                                                      "\n                              "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm.TYPE_OF_SINGLE_SELECT.includes(
                                                                            item
                                                                              .resourceField[0]
                                                                              .type
                                                                          ) &&
                                                                          item
                                                                            .resourceField[0]
                                                                            .master_name &&
                                                                          item
                                                                            .resourceField[0]
                                                                            .name
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                              " +
                                                                                  _vm._s(
                                                                                    _vm.getSingleSelectValue(
                                                                                      item
                                                                                        .resourceField[0]
                                                                                        .master_name,
                                                                                      job[
                                                                                        item
                                                                                          .resourceField[0]
                                                                                          .name
                                                                                      ]
                                                                                    )
                                                                                  ) +
                                                                                  "\n                            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm.TYPE_OF_MULTI_SELECT.includes(
                                                                            item
                                                                              .resourceField[0]
                                                                              .type
                                                                          ) &&
                                                                          item
                                                                            .resourceField[0]
                                                                            .master_name &&
                                                                          item
                                                                            .resourceField[0]
                                                                            .name
                                                                        ? _c(
                                                                            "span",
                                                                            _vm._l(
                                                                              _vm.getMultiSelectValue(
                                                                                item
                                                                                  .resourceField[0]
                                                                                  .master_name,
                                                                                job[
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .name
                                                                                ]
                                                                              ),
                                                                              function(
                                                                                value,
                                                                                index
                                                                              ) {
                                                                                return _c(
                                                                                  "span",
                                                                                  {
                                                                                    key: index
                                                                                  },
                                                                                  [
                                                                                    index !==
                                                                                    0
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              ", "
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _c(
                                                                                      "span",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            value
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              }
                                                                            ),
                                                                            0
                                                                          )
                                                                        : _vm.FORMAT_DATE.includes(
                                                                            item
                                                                              .resourceField[0]
                                                                              .type
                                                                          )
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                              " +
                                                                                  _vm._s(
                                                                                    _vm.getDatetimeString(
                                                                                      item
                                                                                        .resourceField[0]
                                                                                        .type,
                                                                                      job[
                                                                                        item
                                                                                          .resourceField[0]
                                                                                          .name
                                                                                      ]
                                                                                    )
                                                                                  ) +
                                                                                  "\n                            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : item
                                                                            .resourceField[0]
                                                                            .type ===
                                                                          "textarea"
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "white-space"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  job[
                                                                                    item
                                                                                      .resourceField[0]
                                                                                      .name
                                                                                  ]
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : item
                                                                            .resourceField[0]
                                                                            .name ===
                                                                          "staff_id"
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                              " +
                                                                                  _vm._s(
                                                                                    _vm.getStaffNameByStaffId(
                                                                                      job.staff_id
                                                                                    )
                                                                                  ) +
                                                                                  "\n                            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm.TYPE_OF_NUMBER.includes(
                                                                            item
                                                                              .resourceField[0]
                                                                              .type
                                                                          )
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                              " +
                                                                                  _vm._s(
                                                                                    _vm.formatNumberByStep(
                                                                                      job[
                                                                                        item
                                                                                          .resourceField[0]
                                                                                          .name
                                                                                      ],
                                                                                      item
                                                                                        .resourceField[0]
                                                                                        .step
                                                                                    )
                                                                                  ) +
                                                                                  "\n                            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  job[
                                                                                    item
                                                                                      .resourceField[0]
                                                                                      .name
                                                                                  ]
                                                                                )
                                                                              )
                                                                            ]
                                                                          ),
                                                                      item
                                                                        .resourceField[0]
                                                                        .unit
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "ml-1",
                                                                              class: {
                                                                                label_unit_item_long:
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .unit
                                                                                    .length >
                                                                                  _vm
                                                                                    .userConfig
                                                                                    .UNIT_LENGTH,
                                                                                label_unit_item:
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .unit
                                                                                    .length <=
                                                                                  _vm
                                                                                    .userConfig
                                                                                    .UNIT_LENGTH
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .unit
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          item.resourceField[0].name.startsWith(
                                                            _vm
                                                              .jobSettingProperty
                                                              .ITEM_COMPANY_MODIFY
                                                          ) &&
                                                          _vm.getCompanyByCompanyId(
                                                            job.company_id
                                                          )[
                                                            item.resourceField[0].name.substring(
                                                              8
                                                            )
                                                          ] &&
                                                          job[
                                                            _vm
                                                              .companyPublicSetting
                                                          ] === 1
                                                            ? _c(
                                                                "tr",
                                                                {
                                                                  key:
                                                                    item
                                                                      .resourceField[0]
                                                                      .name,
                                                                  staticClass:
                                                                    "jobs_detail_table_rows",
                                                                  attrs: {
                                                                    set: (_vm.companyData = _vm.getCompanyByCompanyId(
                                                                      job.company_id
                                                                    ))
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "th",
                                                                    {
                                                                      staticClass:
                                                                        "jobs_detail_table_head",
                                                                      style: [
                                                                        {
                                                                          backgroundColor:
                                                                            _vm
                                                                              .colorSetting
                                                                              .subColor
                                                                        },
                                                                        index ===
                                                                        0
                                                                          ? {
                                                                              border:
                                                                                "1px solid" +
                                                                                _vm
                                                                                  .colorSetting
                                                                                  .borderColor
                                                                            }
                                                                          : {
                                                                              borderLeft:
                                                                                "1px solid" +
                                                                                _vm
                                                                                  .colorSetting
                                                                                  .borderColor,
                                                                              borderRight:
                                                                                "1px solid" +
                                                                                _vm
                                                                                  .colorSetting
                                                                                  .borderColor,
                                                                              borderBottom:
                                                                                "1px solid" +
                                                                                _vm
                                                                                  .colorSetting
                                                                                  .borderColor
                                                                            }
                                                                      ]
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "setting_word_break",
                                                                          style: {
                                                                            color:
                                                                              _vm
                                                                                .colorSetting
                                                                                .pageText
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                              " +
                                                                              _vm._s(
                                                                                item.itemName
                                                                              ) +
                                                                              "\n                            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "td",
                                                                    {
                                                                      staticClass:
                                                                        "jobs_detail_table_cell word-break",
                                                                      style: {
                                                                        borderTop:
                                                                          "1px solid" +
                                                                          _vm
                                                                            .colorSetting
                                                                            .borderColor,
                                                                        borderRight:
                                                                          "1px solid" +
                                                                          _vm
                                                                            .colorSetting
                                                                            .borderColor,
                                                                        borderBottom:
                                                                          "1px solid" +
                                                                          _vm
                                                                            .colorSetting
                                                                            .borderColor
                                                                      }
                                                                    },
                                                                    [
                                                                      item
                                                                        .resourceField[0]
                                                                        .type ===
                                                                      "free_email"
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  style: {
                                                                                    color:
                                                                                      _vm
                                                                                        .colorSetting
                                                                                        .linkText
                                                                                  },
                                                                                  attrs: {
                                                                                    href:
                                                                                      "mailto:" +
                                                                                      _vm
                                                                                        .companyData[
                                                                                        item.resourceField[0].name.substring(
                                                                                          8
                                                                                        )
                                                                                      ]
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                " +
                                                                                      _vm._s(
                                                                                        _vm
                                                                                          .companyData[
                                                                                          item.resourceField[0].name.substring(
                                                                                            8
                                                                                          )
                                                                                        ]
                                                                                      ) +
                                                                                      "\n                              "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        : item
                                                                            .resourceField[0]
                                                                            .type ===
                                                                          "url"
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  style: {
                                                                                    color:
                                                                                      _vm
                                                                                        .colorSetting
                                                                                        .linkText
                                                                                  },
                                                                                  attrs: {
                                                                                    href:
                                                                                      _vm
                                                                                        .companyData[
                                                                                        item.resourceField[0].name.substring(
                                                                                          8
                                                                                        )
                                                                                      ],
                                                                                    target:
                                                                                      "_blank"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                " +
                                                                                      _vm._s(
                                                                                        _vm
                                                                                          .companyData[
                                                                                          item.resourceField[0].name.substring(
                                                                                            8
                                                                                          )
                                                                                        ]
                                                                                      ) +
                                                                                      "\n                              "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm.TYPE_OF_SINGLE_SELECT.includes(
                                                                            item
                                                                              .resourceField[0]
                                                                              .type
                                                                          ) &&
                                                                          item
                                                                            .resourceField[0]
                                                                            .master_name &&
                                                                          item
                                                                            .resourceField[0]
                                                                            .name
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                              " +
                                                                                  _vm._s(
                                                                                    _vm.getSingleSelectValue(
                                                                                      item
                                                                                        .resourceField[0]
                                                                                        .master_name,
                                                                                      _vm
                                                                                        .companyData[
                                                                                        item.resourceField[0].name.substring(
                                                                                          8
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ) +
                                                                                  "\n                            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm.TYPE_OF_MULTI_SELECT.includes(
                                                                            item
                                                                              .resourceField[0]
                                                                              .type
                                                                          ) &&
                                                                          item
                                                                            .resourceField[0]
                                                                            .master_name &&
                                                                          item
                                                                            .resourceField[0]
                                                                            .name
                                                                        ? _c(
                                                                            "span",
                                                                            _vm._l(
                                                                              _vm.getMultiSelectValue(
                                                                                item
                                                                                  .resourceField[0]
                                                                                  .master_name,
                                                                                _vm
                                                                                  .companyData[
                                                                                  item.resourceField[0].name.substring(
                                                                                    8
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              function(
                                                                                value,
                                                                                index
                                                                              ) {
                                                                                return _c(
                                                                                  "span",
                                                                                  {
                                                                                    key: index
                                                                                  },
                                                                                  [
                                                                                    index !==
                                                                                    0
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              ", "
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _c(
                                                                                      "span",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            value
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              }
                                                                            ),
                                                                            0
                                                                          )
                                                                        : _vm.FORMAT_DATE.includes(
                                                                            item
                                                                              .resourceField[0]
                                                                              .type
                                                                          )
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                              " +
                                                                                  _vm._s(
                                                                                    _vm.getDatetimeString(
                                                                                      item
                                                                                        .resourceField[0]
                                                                                        .type,
                                                                                      _vm
                                                                                        .companyData[
                                                                                        item.resourceField[0].name.substring(
                                                                                          8
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ) +
                                                                                  "\n                            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : item
                                                                            .resourceField[0]
                                                                            .type ===
                                                                          "textarea"
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "white-space"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .companyData[
                                                                                    item.resourceField[0].name.substring(
                                                                                      8
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm.TYPE_OF_NUMBER.includes(
                                                                            item
                                                                              .resourceField[0]
                                                                              .type
                                                                          )
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                              " +
                                                                                  _vm._s(
                                                                                    _vm.formatNumberByStep(
                                                                                      _vm
                                                                                        .companyData[
                                                                                        item.resourceField[0].name.substring(
                                                                                          8
                                                                                        )
                                                                                      ],
                                                                                      item
                                                                                        .resourceField[0]
                                                                                        .step
                                                                                    )
                                                                                  ) +
                                                                                  "\n                            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm.isObjectDataHasValue(
                                                                            _vm
                                                                              .companyData[
                                                                              item.resourceField[0].name.substring(
                                                                                8
                                                                              )
                                                                            ]
                                                                          )
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .companyData[
                                                                                    item.resourceField[0].name.substring(
                                                                                      8
                                                                                    )
                                                                                  ]
                                                                                    .data
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .companyData[
                                                                                    item.resourceField[0].name.substring(
                                                                                      8
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              )
                                                                            ]
                                                                          ),
                                                                      item
                                                                        .resourceField[0]
                                                                        .unit
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "ml-1",
                                                                              class: {
                                                                                label_unit_item_long:
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .unit
                                                                                    .length >
                                                                                  _vm
                                                                                    .userConfig
                                                                                    .UNIT_LENGTH,
                                                                                label_unit_item:
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .unit
                                                                                    .length <=
                                                                                  _vm
                                                                                    .userConfig
                                                                                    .UNIT_LENGTH
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .unit
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              ),
                              _c("div", { staticClass: "jobs_result_btn" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "jobs_btn_primary",
                                    style: {
                                      color: _vm.colorSetting.mainButtonText,
                                      backgroundColor:
                                        _vm.colorSetting.mainButton
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.viewDetailJob(
                                          job.id,
                                          _vm.DETAIL_FORM_TYPE
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm.button.listBtn === ""
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.searchJobLabelsProperty
                                                  .VIEW_DETAIL_JOB
                                              ) +
                                              "\n                "
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.button.listBtn) +
                                              "\n                "
                                          )
                                        ])
                                  ]
                                )
                              ])
                            ])
                          : _c("li", { staticClass: "jobs_result_item" }, [
                              _c(
                                "div",
                                { staticClass: "jobs_result_inner" },
                                [
                                  _c(
                                    "h2",
                                    { staticClass: "jobs_result_heading" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            target: _vm.jobNewWindow
                                              ? "_blank"
                                              : "",
                                            to:
                                              "/?c=" +
                                              encodeURIComponent(
                                                _vm.encryptJobCode
                                              ) +
                                              "&jid=" +
                                              job.id +
                                              "&query=" +
                                              encodeURIComponent(
                                                _vm.keyRedisSearch
                                              ) +
                                              "&jt=" +
                                              _vm.DISPATCH_DETAIL_FORM_TYPE
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              !_vm.jobNewWindow
                                                ? _vm.onTopOfIframe()
                                                : null
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "jobs_result_title",
                                              staticStyle: {
                                                "text-decoration": "none"
                                              },
                                              style: {
                                                color: _vm.colorSetting.linkText
                                              }
                                            },
                                            [
                                              _vm._l(
                                                _vm.headingDispatchJobSettings,
                                                function(
                                                  headingSetting,
                                                  index
                                                ) {
                                                  return [
                                                    _vm.getSubItemValue(
                                                      job,
                                                      headingSetting.name
                                                    ) &&
                                                    _vm.getDispatchResourceType(
                                                      headingSetting.name
                                                    )
                                                      ? [
                                                          _c(
                                                            "span",
                                                            {
                                                              key:
                                                                "list_heading_dp" +
                                                                index,
                                                              attrs: {
                                                                set: (_vm.item = {
                                                                  typeOfItem: _vm.getDispatchResourceType(
                                                                    headingSetting.name
                                                                  ),
                                                                  itemValue: _vm.getSubItemValue(
                                                                    job,
                                                                    headingSetting.name
                                                                  )
                                                                })
                                                              }
                                                            },
                                                            [
                                                              _vm.isPreviousItemHaveData(
                                                                job,
                                                                headingSetting.name,
                                                                index,
                                                                _vm
                                                                  .headingDispatchJobSettings[
                                                                  index
                                                                    ? index - 1
                                                                    : index
                                                                ].name,
                                                                _vm.headingDispatchJobSettings
                                                              )
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                            /\n                          "
                                                                    )
                                                                  ])
                                                                : _vm._e(),
                                                              _vm.item
                                                                .typeOfItem
                                                                .name ===
                                                              "company_id"
                                                                ? _c("span", [
                                                                    job[
                                                                      _vm
                                                                        .companyDispatchPublicSetting
                                                                    ] === 1
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm.getCompanyNameByCompanyId(
                                                                              job.company_id
                                                                            )
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                " +
                                                                                        _vm._s(
                                                                                          _vm.getCompanyNameByCompanyId(
                                                                                            job.company_id
                                                                                          )
                                                                                        ) +
                                                                                        "\n                              "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                " +
                                                                                        _vm._s(
                                                                                          _vm
                                                                                            .searchJobLabelsProperty
                                                                                            .NAME_COMPANY_UNREGISTER
                                                                                        ) +
                                                                                        "\n                              "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .searchJobLabelsProperty
                                                                                    .NAME_COMPANY_PRIVATE
                                                                                ) +
                                                                                "\n                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                  ])
                                                                : _vm.item
                                                                    .typeOfItem
                                                                    .name ===
                                                                  "staff_id"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.getStaffNameByStaffId(
                                                                            job.staff_id
                                                                          )
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ])
                                                                : _vm.item
                                                                    .typeOfItem
                                                                    .type ===
                                                                  "free_email"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .item
                                                                            .itemValue
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ])
                                                                : _vm.item
                                                                    .typeOfItem
                                                                    .type ===
                                                                  "url"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .item
                                                                            .itemValue
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ])
                                                                : _vm.checkHaveMasterData(
                                                                    headingSetting.name
                                                                  ) &&
                                                                  _vm.TYPE_OF_SINGLE_SELECT.includes(
                                                                    _vm.item
                                                                      .typeOfItem
                                                                      .type
                                                                  ) &&
                                                                  _vm.item
                                                                    .typeOfItem
                                                                    .master_name &&
                                                                  _vm.item
                                                                    .typeOfItem
                                                                    .name
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.getSingleSelectValue(
                                                                            _vm
                                                                              .item
                                                                              .typeOfItem
                                                                              .master_name,
                                                                            _vm
                                                                              .item
                                                                              .itemValue
                                                                          )
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ])
                                                                : _vm.checkHaveMasterData(
                                                                    headingSetting.name
                                                                  ) &&
                                                                  _vm.TYPE_OF_MULTI_SELECT.includes(
                                                                    _vm.item
                                                                      .typeOfItem
                                                                      .type
                                                                  ) &&
                                                                  _vm.item
                                                                    .typeOfItem
                                                                    .master_name &&
                                                                  _vm.item
                                                                    .typeOfItem
                                                                    .name
                                                                ? _c(
                                                                    "span",
                                                                    _vm._l(
                                                                      _vm.getMultiSelectValue(
                                                                        _vm.item
                                                                          .typeOfItem
                                                                          .master_name,
                                                                        _vm.item
                                                                          .itemValue
                                                                      ),
                                                                      function(
                                                                        value,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          {
                                                                            key: index
                                                                          },
                                                                          [
                                                                            index !==
                                                                            0
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      ", "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    value
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                : !_vm.checkHaveMasterData(
                                                                    headingSetting.name
                                                                  ) &&
                                                                  _vm.TYPE_OF_SINGLE_SELECT.includes(
                                                                    _vm.item
                                                                      .typeOfItem
                                                                      .type
                                                                  )
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.getValueFromApiMaster(
                                                                            job,
                                                                            headingSetting.name
                                                                          )
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ])
                                                                : !_vm.checkHaveMasterData(
                                                                    headingSetting.name
                                                                  ) &&
                                                                  _vm.TYPE_OF_MULTI_SELECT.includes(
                                                                    _vm.item
                                                                      .typeOfItem
                                                                      .type
                                                                  )
                                                                ? _c(
                                                                    "span",
                                                                    _vm._l(
                                                                      _vm.getValueFromApiMaster(
                                                                        job,
                                                                        headingSetting.name
                                                                      ),
                                                                      function(
                                                                        value,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          {
                                                                            key: index
                                                                          },
                                                                          [
                                                                            index !==
                                                                            0
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      ", "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    value
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                : _vm.FORMAT_DATE.includes(
                                                                    _vm.item
                                                                      .typeOfItem
                                                                      .type
                                                                  )
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.getDatetimeString(
                                                                            _vm
                                                                              .item
                                                                              .typeOfItem
                                                                              .type,
                                                                            _vm
                                                                              .item
                                                                              .itemValue
                                                                          )
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ])
                                                                : _vm.TYPE_OF_NUMBER.includes(
                                                                    _vm.item
                                                                      .typeOfItem
                                                                      .type
                                                                  )
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.formatNumberByStep(
                                                                            _vm
                                                                              .item
                                                                              .itemValue,
                                                                            _vm
                                                                              .item
                                                                              .typeOfItem
                                                                              .step
                                                                          )
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ])
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .item
                                                                            .itemValue
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ]),
                                                              _vm.item
                                                                .typeOfItem.unit
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "ml-1",
                                                                      class: {
                                                                        label_unit_item_long:
                                                                          _vm
                                                                            .item
                                                                            .typeOfItem
                                                                            .unit
                                                                            .length >
                                                                          _vm
                                                                            .userConfig
                                                                            .UNIT_LENGTH,
                                                                        label_unit_item:
                                                                          _vm
                                                                            .item
                                                                            .typeOfItem
                                                                            .unit
                                                                            .length <=
                                                                          _vm
                                                                            .userConfig
                                                                            .UNIT_LENGTH
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm
                                                                            .item
                                                                            .typeOfItem
                                                                            .unit
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      : _vm._e()
                                                  ]
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._l(_vm.bodyDispatchJobSettings, function(
                                    bodySetting,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "jobs_result_text"
                                      },
                                      [
                                        _vm.getDispatchResourceType(
                                          bodySetting.name
                                        ) &&
                                        _vm.getSubItemValue(
                                          job,
                                          bodySetting.name
                                        )
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  attrs: {
                                                    set: (_vm.item = {
                                                      typeOfItem: _vm.getDispatchResourceType(
                                                        bodySetting.name
                                                      ),
                                                      itemValue: _vm.getSubItemValue(
                                                        job,
                                                        bodySetting.name
                                                      )
                                                    })
                                                  }
                                                },
                                                [
                                                  _vm.item.typeOfItem.name ===
                                                  "company_id"
                                                    ? _c("span", [
                                                        job[
                                                          _vm
                                                            .companyDispatchPublicSetting
                                                        ] === 1
                                                          ? _c("span", [
                                                              _vm.getCompanyNameByCompanyId(
                                                                job.company_id
                                                              )
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm.getCompanyNameByCompanyId(
                                                                            job.company_id
                                                                          )
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ])
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .searchJobLabelsProperty
                                                                            .NAME_COMPANY_UNREGISTER
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ])
                                                            ])
                                                          : _c("span", [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .searchJobLabelsProperty
                                                                      .NAME_COMPANY_PRIVATE
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ])
                                                      ])
                                                    : _vm.item.typeOfItem
                                                        .name === "staff_id"
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.getStaffNameByStaffId(
                                                                job.staff_id
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ])
                                                    : _vm.item.typeOfItem
                                                        .type === "free_email"
                                                    ? _c("span", [
                                                        _c(
                                                          "a",
                                                          {
                                                            style: {
                                                              color:
                                                                _vm.colorSetting
                                                                  .linkText
                                                            },
                                                            attrs: {
                                                              href:
                                                                "mailto:" +
                                                                _vm.item
                                                                  .itemValue
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.item
                                                                    .itemValue
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    : _vm.item.typeOfItem
                                                        .type === "url"
                                                    ? _c("span", [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticStyle: {
                                                              "text-decoration":
                                                                "none"
                                                            },
                                                            style: {
                                                              color:
                                                                _vm.colorSetting
                                                                  .linkText
                                                            },
                                                            attrs: {
                                                              href:
                                                                _vm.item
                                                                  .itemValue,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.item
                                                                    .itemValue
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    : _vm.checkHaveMasterData(
                                                        bodySetting.name
                                                      ) &&
                                                      _vm.TYPE_OF_SINGLE_SELECT.includes(
                                                        _vm.item.typeOfItem.type
                                                      ) &&
                                                      _vm.item.typeOfItem
                                                        .master_name &&
                                                      _vm.item.typeOfItem.name
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.getSingleSelectValue(
                                                                _vm.item
                                                                  .typeOfItem
                                                                  .master_name,
                                                                _vm.item
                                                                  .itemValue
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ])
                                                    : _vm.checkHaveMasterData(
                                                        bodySetting.name
                                                      ) &&
                                                      _vm.TYPE_OF_MULTI_SELECT.includes(
                                                        _vm.item.typeOfItem.type
                                                      ) &&
                                                      _vm.item.typeOfItem
                                                        .master_name &&
                                                      _vm.item.typeOfItem.name
                                                    ? _c(
                                                        "span",
                                                        _vm._l(
                                                          _vm.getMultiSelectValue(
                                                            _vm.item.typeOfItem
                                                              .master_name,
                                                            _vm.item.itemValue
                                                          ),
                                                          function(
                                                            value,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "span",
                                                              { key: index },
                                                              [
                                                                index !== 0
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        ", "
                                                                      )
                                                                    ])
                                                                  : _vm._e(),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      value
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : !_vm.checkHaveMasterData(
                                                        bodySetting.name
                                                      ) &&
                                                      _vm.TYPE_OF_SINGLE_SELECT.includes(
                                                        _vm.item.typeOfItem.type
                                                      )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.getValueFromApiMaster(
                                                                job,
                                                                bodySetting.name
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ])
                                                    : !_vm.checkHaveMasterData(
                                                        bodySetting.name
                                                      ) &&
                                                      _vm.TYPE_OF_MULTI_SELECT.includes(
                                                        _vm.item.typeOfItem.type
                                                      )
                                                    ? _c(
                                                        "span",
                                                        _vm._l(
                                                          _vm.getValueFromApiMaster(
                                                            job,
                                                            bodySetting.name
                                                          ),
                                                          function(
                                                            value,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "span",
                                                              { key: index },
                                                              [
                                                                index !== 0
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        ", "
                                                                      )
                                                                    ])
                                                                  : _vm._e(),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      value
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm.FORMAT_DATE.includes(
                                                        _vm.item.typeOfItem.type
                                                      )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.getDatetimeString(
                                                                _vm.item
                                                                  .typeOfItem
                                                                  .type,
                                                                _vm.item
                                                                  .itemValue
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ])
                                                    : _vm.TYPE_OF_NUMBER.includes(
                                                        _vm.item.typeOfItem.type
                                                      )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.formatNumberByStep(
                                                                _vm.item
                                                                  .itemValue,
                                                                _vm.item
                                                                  .typeOfItem
                                                                  .step
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ])
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "pre-margin-bottom line_break_setting_text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.item.itemValue
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                  _vm.item.typeOfItem.unit
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "ml-1",
                                                          class: {
                                                            label_unit_item_long:
                                                              _vm.item
                                                                .typeOfItem.unit
                                                                .length >
                                                              _vm.userConfig
                                                                .UNIT_LENGTH,
                                                            label_unit_item:
                                                              _vm.item
                                                                .typeOfItem.unit
                                                                .length <=
                                                              _vm.userConfig
                                                                .UNIT_LENGTH
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.item
                                                                .typeOfItem.unit
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  }),
                                  _vm._l(
                                    _vm.categoriesDispatchJobList,
                                    function(category, cIndex) {
                                      return [
                                        category &&
                                        !category.categoryDeleted &&
                                        !_vm.isEmptyCategory(
                                          cIndex,
                                          indexJobDetail,
                                          job.flag
                                        )
                                          ? [
                                              _c(
                                                "h2",
                                                {
                                                  key: "cate_name" + cIndex,
                                                  staticClass:
                                                    "jobs_category_title mt-3",
                                                  style: {
                                                    color:
                                                      _vm.colorSetting.pageText,
                                                    borderLeftColor:
                                                      _vm.colorSetting.keyColor
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        category.categoryName
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "table",
                                                {
                                                  key: "item_by_cate" + cIndex,
                                                  staticClass:
                                                    "jobs_detail_table"
                                                },
                                                [
                                                  _c(
                                                    "tbody",
                                                    {
                                                      staticClass:
                                                        "jobs_detail_table_body"
                                                    },
                                                    [
                                                      _vm._l(
                                                        category.item.filter(
                                                          function(item) {
                                                            return !item
                                                              .resourceField[0]
                                                              .isDeletedByMainSystem
                                                          }
                                                        ),
                                                        function(item, index) {
                                                          return [
                                                            !item.resourceField[0].name.startsWith(
                                                              _vm
                                                                .jobSettingProperty
                                                                .ITEM_COMPANY_MODIFY
                                                            ) &&
                                                            _vm.getSubItemValue(
                                                              job,
                                                              item
                                                                .resourceField[0]
                                                                .name
                                                            ) &&
                                                            ((item
                                                              .resourceField[0]
                                                              .name ===
                                                              "company_id" &&
                                                              job[
                                                                _vm
                                                                  .companyDispatchPublicSetting
                                                              ] === 1 &&
                                                              _vm.getCompanyNameByCompanyId(
                                                                job.company_id
                                                              )) ||
                                                              item
                                                                .resourceField[0]
                                                                .name !==
                                                                "company_id")
                                                              ? _c(
                                                                  "tr",
                                                                  {
                                                                    key:
                                                                      item
                                                                        .resourceField[0]
                                                                        .name,
                                                                    staticClass:
                                                                      "jobs_detail_table_rows",
                                                                    attrs: {
                                                                      set: (_vm.itemSetting = {
                                                                        typeOfItem: _vm.getDispatchResourceType(
                                                                          item
                                                                            .resourceField[0]
                                                                            .name
                                                                        ),
                                                                        itemValue: _vm.getSubItemValue(
                                                                          job,
                                                                          item
                                                                            .resourceField[0]
                                                                            .name
                                                                        )
                                                                      })
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "th",
                                                                      {
                                                                        staticClass:
                                                                          "jobs_detail_table_head",
                                                                        style: [
                                                                          {
                                                                            backgroundColor:
                                                                              _vm
                                                                                .colorSetting
                                                                                .subColor
                                                                          },
                                                                          index ===
                                                                          0
                                                                            ? {
                                                                                border:
                                                                                  "1px solid" +
                                                                                  _vm
                                                                                    .colorSetting
                                                                                    .borderColor
                                                                              }
                                                                            : {
                                                                                borderLeft:
                                                                                  "1px solid" +
                                                                                  _vm
                                                                                    .colorSetting
                                                                                    .borderColor,
                                                                                borderRight:
                                                                                  "1px solid" +
                                                                                  _vm
                                                                                    .colorSetting
                                                                                    .borderColor,
                                                                                borderBottom:
                                                                                  "1px solid" +
                                                                                  _vm
                                                                                    .colorSetting
                                                                                    .borderColor
                                                                              }
                                                                        ]
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "setting_word_break",
                                                                            style: {
                                                                              color:
                                                                                _vm
                                                                                  .colorSetting
                                                                                  .pageText
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  item.itemName
                                                                                ) +
                                                                                "\n                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "jobs_detail_table_cell word-break",
                                                                        style: {
                                                                          borderTop:
                                                                            "1px solid" +
                                                                            _vm
                                                                              .colorSetting
                                                                              .borderColor,
                                                                          borderRight:
                                                                            "1px solid" +
                                                                            _vm
                                                                              .colorSetting
                                                                              .borderColor,
                                                                          borderBottom:
                                                                            "1px solid" +
                                                                            _vm
                                                                              .colorSetting
                                                                              .borderColor
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm
                                                                          .itemSetting
                                                                          .typeOfItem
                                                                          .name ===
                                                                        "company_id"
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                              " +
                                                                                    _vm._s(
                                                                                      _vm.getCompanyNameByCompanyId(
                                                                                        job.company_id
                                                                                      )
                                                                                    ) +
                                                                                    "\n                            "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm
                                                                              .itemSetting
                                                                              .typeOfItem
                                                                              .type ===
                                                                            "free_email"
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _c(
                                                                                  "a",
                                                                                  {
                                                                                    style: {
                                                                                      color:
                                                                                        _vm
                                                                                          .colorSetting
                                                                                          .linkText
                                                                                    },
                                                                                    attrs: {
                                                                                      href:
                                                                                        "mailto:" +
                                                                                        _vm
                                                                                          .itemSetting
                                                                                          .itemValue
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                " +
                                                                                        _vm._s(
                                                                                          _vm
                                                                                            .itemSetting
                                                                                            .itemValue
                                                                                        ) +
                                                                                        "\n                              "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm
                                                                              .itemSetting
                                                                              .typeOfItem
                                                                              .type ===
                                                                            "url"
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _c(
                                                                                  "a",
                                                                                  {
                                                                                    style: {
                                                                                      color:
                                                                                        _vm
                                                                                          .colorSetting
                                                                                          .linkText
                                                                                    },
                                                                                    attrs: {
                                                                                      href:
                                                                                        _vm
                                                                                          .itemSetting
                                                                                          .itemValue,
                                                                                      target:
                                                                                        "_blank"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                " +
                                                                                        _vm._s(
                                                                                          _vm
                                                                                            .itemSetting
                                                                                            .itemValue
                                                                                        ) +
                                                                                        "\n                              "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm.checkHaveMasterData(
                                                                              item
                                                                                .resourceField[0]
                                                                                .name
                                                                            ) &&
                                                                            _vm.TYPE_OF_SINGLE_SELECT.includes(
                                                                              _vm
                                                                                .itemSetting
                                                                                .typeOfItem
                                                                                .type
                                                                            ) &&
                                                                            _vm
                                                                              .itemSetting
                                                                              .typeOfItem
                                                                              .master_name &&
                                                                            item
                                                                              .resourceField[0]
                                                                              .name
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                              " +
                                                                                    _vm._s(
                                                                                      _vm.getSingleSelectValue(
                                                                                        _vm
                                                                                          .itemSetting
                                                                                          .typeOfItem
                                                                                          .master_name,
                                                                                        _vm
                                                                                          .itemSetting
                                                                                          .itemValue
                                                                                      )
                                                                                    ) +
                                                                                    "\n                            "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm.checkHaveMasterData(
                                                                              item
                                                                                .resourceField[0]
                                                                                .name
                                                                            ) &&
                                                                            _vm.TYPE_OF_MULTI_SELECT.includes(
                                                                              _vm
                                                                                .itemSetting
                                                                                .typeOfItem
                                                                                .type
                                                                            ) &&
                                                                            _vm
                                                                              .itemSetting
                                                                              .typeOfItem
                                                                              .master_name &&
                                                                            item
                                                                              .resourceField[0]
                                                                              .name
                                                                          ? _c(
                                                                              "span",
                                                                              _vm._l(
                                                                                _vm.getMultiSelectValue(
                                                                                  _vm
                                                                                    .itemSetting
                                                                                    .typeOfItem
                                                                                    .master_name,
                                                                                  _vm
                                                                                    .itemSetting
                                                                                    .itemValue
                                                                                ),
                                                                                function(
                                                                                  value,
                                                                                  index
                                                                                ) {
                                                                                  return _c(
                                                                                    "span",
                                                                                    {
                                                                                      key: index
                                                                                    },
                                                                                    [
                                                                                      index !==
                                                                                      0
                                                                                        ? _c(
                                                                                            "span",
                                                                                            [
                                                                                              _vm._v(
                                                                                                ", "
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              value
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              0
                                                                            )
                                                                          : !_vm.checkHaveMasterData(
                                                                              item
                                                                                .resourceField[0]
                                                                                .name
                                                                            ) &&
                                                                            _vm.TYPE_OF_SINGLE_SELECT.includes(
                                                                              _vm
                                                                                .itemSetting
                                                                                .typeOfItem
                                                                                .type
                                                                            )
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                              " +
                                                                                    _vm._s(
                                                                                      _vm.getValueFromApiMaster(
                                                                                        job,
                                                                                        item
                                                                                          .resourceField[0]
                                                                                          .name
                                                                                      )
                                                                                    ) +
                                                                                    "\n                            "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : !_vm.checkHaveMasterData(
                                                                              item
                                                                                .resourceField[0]
                                                                                .name
                                                                            ) &&
                                                                            _vm.TYPE_OF_MULTI_SELECT.includes(
                                                                              _vm
                                                                                .itemSetting
                                                                                .typeOfItem
                                                                                .type
                                                                            )
                                                                          ? _c(
                                                                              "span",
                                                                              _vm._l(
                                                                                _vm.getValueFromApiMaster(
                                                                                  job,
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .name
                                                                                ),
                                                                                function(
                                                                                  value,
                                                                                  index
                                                                                ) {
                                                                                  return _c(
                                                                                    "span",
                                                                                    {
                                                                                      key: index
                                                                                    },
                                                                                    [
                                                                                      index !==
                                                                                      0
                                                                                        ? _c(
                                                                                            "span",
                                                                                            [
                                                                                              _vm._v(
                                                                                                ", "
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              value
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              0
                                                                            )
                                                                          : _vm.FORMAT_DATE.includes(
                                                                              _vm
                                                                                .itemSetting
                                                                                .typeOfItem
                                                                                .type
                                                                            )
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                              " +
                                                                                    _vm._s(
                                                                                      _vm.getDatetimeString(
                                                                                        _vm
                                                                                          .itemSetting
                                                                                          .typeOfItem
                                                                                          .type,
                                                                                        _vm
                                                                                          .itemSetting
                                                                                          .itemValue
                                                                                      )
                                                                                    ) +
                                                                                    "\n                            "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm
                                                                              .itemSetting
                                                                              .typeOfItem
                                                                              .type ===
                                                                            "textarea"
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "white-space"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .itemSetting
                                                                                      .itemValue
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm
                                                                              .itemSetting
                                                                              .typeOfItem
                                                                              .name ===
                                                                            "staff_id"
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                              " +
                                                                                    _vm._s(
                                                                                      _vm.getStaffNameByStaffId(
                                                                                        job.staff_id
                                                                                      )
                                                                                    ) +
                                                                                    "\n                            "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm.TYPE_OF_NUMBER.includes(
                                                                              _vm
                                                                                .itemSetting
                                                                                .typeOfItem
                                                                                .type
                                                                            )
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                              " +
                                                                                    _vm._s(
                                                                                      _vm.formatNumberByStep(
                                                                                        _vm
                                                                                          .itemSetting
                                                                                          .itemValue,
                                                                                        _vm
                                                                                          .itemSetting
                                                                                          .typeOfItem
                                                                                          .step
                                                                                      )
                                                                                    ) +
                                                                                    "\n                            "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .itemSetting
                                                                                      .itemValue
                                                                                  )
                                                                                )
                                                                              ]
                                                                            ),
                                                                        _vm
                                                                          .itemSetting
                                                                          .typeOfItem
                                                                          .unit
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "ml-1",
                                                                                class: {
                                                                                  label_unit_item_long:
                                                                                    _vm
                                                                                      .itemSetting
                                                                                      .typeOfItem
                                                                                      .unit
                                                                                      .length >
                                                                                    _vm
                                                                                      .userConfig
                                                                                      .UNIT_LENGTH,
                                                                                  label_unit_item:
                                                                                    _vm
                                                                                      .itemSetting
                                                                                      .typeOfItem
                                                                                      .unit
                                                                                      .length <=
                                                                                    _vm
                                                                                      .userConfig
                                                                                      .UNIT_LENGTH
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .itemSetting
                                                                                      .typeOfItem
                                                                                      .unit
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e()
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            item.resourceField[0].name.startsWith(
                                                              _vm
                                                                .jobSettingProperty
                                                                .ITEM_COMPANY_MODIFY
                                                            ) &&
                                                            _vm.getCompanyByCompanyId(
                                                              job.company_id
                                                            ) &&
                                                            job[
                                                              _vm
                                                                .companyDispatchPublicSetting
                                                            ] === 1
                                                              ? _c(
                                                                  "tr",
                                                                  {
                                                                    key:
                                                                      item
                                                                        .resourceField[0]
                                                                        .name,
                                                                    staticClass:
                                                                      "jobs_detail_table_rows",
                                                                    attrs: {
                                                                      set: (_vm.companyData = _vm.getCompanyByCompanyId(
                                                                        job.company_id
                                                                      ))
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "th",
                                                                      {
                                                                        staticClass:
                                                                          "jobs_detail_table_head",
                                                                        style: [
                                                                          {
                                                                            backgroundColor:
                                                                              _vm
                                                                                .colorSetting
                                                                                .subColor
                                                                          },
                                                                          index ===
                                                                          0
                                                                            ? {
                                                                                border:
                                                                                  "1px solid" +
                                                                                  _vm
                                                                                    .colorSetting
                                                                                    .borderColor
                                                                              }
                                                                            : {
                                                                                borderLeft:
                                                                                  "1px solid" +
                                                                                  _vm
                                                                                    .colorSetting
                                                                                    .borderColor,
                                                                                borderRight:
                                                                                  "1px solid" +
                                                                                  _vm
                                                                                    .colorSetting
                                                                                    .borderColor,
                                                                                borderBottom:
                                                                                  "1px solid" +
                                                                                  _vm
                                                                                    .colorSetting
                                                                                    .borderColor
                                                                              }
                                                                        ]
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "setting_word_break",
                                                                            style: {
                                                                              color:
                                                                                _vm
                                                                                  .colorSetting
                                                                                  .pageText
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  item.itemName
                                                                                ) +
                                                                                "\n                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "jobs_detail_table_cell word-break",
                                                                        style: {
                                                                          borderTop:
                                                                            "1px solid" +
                                                                            _vm
                                                                              .colorSetting
                                                                              .borderColor,
                                                                          borderRight:
                                                                            "1px solid" +
                                                                            _vm
                                                                              .colorSetting
                                                                              .borderColor,
                                                                          borderBottom:
                                                                            "1px solid" +
                                                                            _vm
                                                                              .colorSetting
                                                                              .borderColor
                                                                        }
                                                                      },
                                                                      [
                                                                        item
                                                                          .resourceField[0]
                                                                          .type ===
                                                                        "free_email"
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _c(
                                                                                  "a",
                                                                                  {
                                                                                    style: {
                                                                                      color:
                                                                                        _vm
                                                                                          .colorSetting
                                                                                          .linkText
                                                                                    },
                                                                                    attrs: {
                                                                                      href:
                                                                                        "mailto:" +
                                                                                        _vm
                                                                                          .companyData[
                                                                                          item.resourceField[0].name.substring(
                                                                                            8
                                                                                          )
                                                                                        ]
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                " +
                                                                                        _vm._s(
                                                                                          _vm
                                                                                            .companyData[
                                                                                            item.resourceField[0].name.substring(
                                                                                              8
                                                                                            )
                                                                                          ]
                                                                                        ) +
                                                                                        "\n                              "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          : item
                                                                              .resourceField[0]
                                                                              .type ===
                                                                            "url"
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _c(
                                                                                  "a",
                                                                                  {
                                                                                    style: {
                                                                                      color:
                                                                                        _vm
                                                                                          .colorSetting
                                                                                          .linkText
                                                                                    },
                                                                                    attrs: {
                                                                                      href:
                                                                                        _vm
                                                                                          .companyData[
                                                                                          item.resourceField[0].name.substring(
                                                                                            8
                                                                                          )
                                                                                        ],
                                                                                      target:
                                                                                        "_blank"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                " +
                                                                                        _vm._s(
                                                                                          _vm
                                                                                            .companyData[
                                                                                            item.resourceField[0].name.substring(
                                                                                              8
                                                                                            )
                                                                                          ]
                                                                                        ) +
                                                                                        "\n                              "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm.TYPE_OF_SINGLE_SELECT.includes(
                                                                              item
                                                                                .resourceField[0]
                                                                                .type
                                                                            ) &&
                                                                            item
                                                                              .resourceField[0]
                                                                              .master_name &&
                                                                            item
                                                                              .resourceField[0]
                                                                              .name
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                              " +
                                                                                    _vm._s(
                                                                                      _vm.getSingleSelectValue(
                                                                                        item
                                                                                          .resourceField[0]
                                                                                          .master_name,
                                                                                        _vm
                                                                                          .companyData[
                                                                                          item.resourceField[0].name.substring(
                                                                                            8
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ) +
                                                                                    "\n                            "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm.TYPE_OF_MULTI_SELECT.includes(
                                                                              item
                                                                                .resourceField[0]
                                                                                .type
                                                                            ) &&
                                                                            item
                                                                              .resourceField[0]
                                                                              .master_name &&
                                                                            item
                                                                              .resourceField[0]
                                                                              .name
                                                                          ? _c(
                                                                              "span",
                                                                              _vm._l(
                                                                                _vm.getMultiSelectValue(
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .master_name,
                                                                                  _vm
                                                                                    .companyData[
                                                                                    item.resourceField[0].name.substring(
                                                                                      8
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                function(
                                                                                  value,
                                                                                  index
                                                                                ) {
                                                                                  return _c(
                                                                                    "span",
                                                                                    {
                                                                                      key: index
                                                                                    },
                                                                                    [
                                                                                      index !==
                                                                                      0
                                                                                        ? _c(
                                                                                            "span",
                                                                                            [
                                                                                              _vm._v(
                                                                                                ", "
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              value
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              0
                                                                            )
                                                                          : _vm.FORMAT_DATE.includes(
                                                                              item
                                                                                .resourceField[0]
                                                                                .type
                                                                            )
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                              " +
                                                                                    _vm._s(
                                                                                      _vm.getDatetimeString(
                                                                                        item
                                                                                          .resourceField[0]
                                                                                          .type,
                                                                                        _vm
                                                                                          .companyData[
                                                                                          item.resourceField[0].name.substring(
                                                                                            8
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ) +
                                                                                    "\n                            "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : item
                                                                              .resourceField[0]
                                                                              .type ===
                                                                            "textarea"
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "white-space"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .companyData[
                                                                                      item.resourceField[0].name.substring(
                                                                                        8
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm.TYPE_OF_NUMBER.includes(
                                                                              item
                                                                                .resourceField[0]
                                                                                .type
                                                                            )
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                              " +
                                                                                    _vm._s(
                                                                                      _vm.formatNumberByStep(
                                                                                        _vm
                                                                                          .companyData[
                                                                                          item.resourceField[0].name.substring(
                                                                                            8
                                                                                          )
                                                                                        ],
                                                                                        item
                                                                                          .resourceField[0]
                                                                                          .step
                                                                                      )
                                                                                    ) +
                                                                                    "\n                            "
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm.isObjectDataHasValue(
                                                                              _vm
                                                                                .companyData[
                                                                                item.resourceField[0].name.substring(
                                                                                  8
                                                                                )
                                                                              ]
                                                                            )
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .companyData[
                                                                                      item.resourceField[0].name.substring(
                                                                                        8
                                                                                      )
                                                                                    ]
                                                                                      .data
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .companyData[
                                                                                      item.resourceField[0].name.substring(
                                                                                        8
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                )
                                                                              ]
                                                                            ),
                                                                        item
                                                                          .resourceField[0]
                                                                          .unit
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "ml-1",
                                                                                class: {
                                                                                  label_unit_item_long:
                                                                                    item
                                                                                      .resourceField[0]
                                                                                      .unit
                                                                                      .length >
                                                                                    _vm
                                                                                      .userConfig
                                                                                      .UNIT_LENGTH,
                                                                                  label_unit_item:
                                                                                    item
                                                                                      .resourceField[0]
                                                                                      .unit
                                                                                      .length <=
                                                                                    _vm
                                                                                      .userConfig
                                                                                      .UNIT_LENGTH
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item
                                                                                      .resourceField[0]
                                                                                      .unit
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e()
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ]
                                    }
                                  )
                                ],
                                2
                              ),
                              _c("div", { staticClass: "jobs_result_btn" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "jobs_btn_primary",
                                    style: {
                                      color: _vm.colorSetting.mainButtonText,
                                      backgroundColor:
                                        _vm.colorSetting.mainButton
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.viewDetailJob(
                                          job.id,
                                          _vm.DISPATCH_DETAIL_FORM_TYPE
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm.button.listBtn === ""
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.searchJobLabelsProperty
                                                  .VIEW_DETAIL_JOB
                                              ) +
                                              "\n                "
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.button.listBtn) +
                                              "\n                "
                                          )
                                        ])
                                  ]
                                )
                              ])
                            ])
                      ]
                    )
                  }),
                  0
                ),
                _c("div", { staticClass: "jobs_btn_box" }, [
                  _vm.maxResultJobDisplay < _vm.idJobs.length
                    ? _c(
                        "button",
                        {
                          staticClass: "jobs_btn_secondary jobs_btn_medium",
                          class: _vm.page !== 1 ? "" : "jobs_btn_disabled",
                          style: {
                            color: _vm.colorSetting.subButtonText,
                            backgroundColor: _vm.colorSetting.subButton
                          },
                          on: { click: _vm.previousPage }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.searchJobLabelsProperty.BUTTON_BACK_PAGE
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.page < _vm.pages.length &&
                  _vm.toJob < _vm.totalResultSearchJob
                    ? _c(
                        "button",
                        {
                          staticClass: "jobs_btn_secondary jobs_btn_medium",
                          style: {
                            color: _vm.colorSetting.subButtonText,
                            backgroundColor: _vm.colorSetting.subButton
                          },
                          on: { click: _vm.nextPage }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.searchJobLabelsProperty.BUTTON_NEXT_PAGE
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
        ])
      : _vm._e(),
    _c("div", { ref: "ref_botton_top", staticClass: "setting_botton_top" }, [
      _c(
        "button",
        {
          staticClass: "setting_btn_primary",
          style: {
            color: _vm.colorSetting.mainButtonText,
            backgroundColor: _vm.colorSetting.mainButton,
            border: "1px solid" + _vm.colorSetting.borderColor
          },
          on: { click: _vm.onTopPage }
        },
        [
          _c(
            "svg",
            {
              attrs: {
                stroke: "currentColor",
                fill: "currentColor",
                "stroke-width": "0",
                viewBox: "0 0 320 512",
                height: "1em",
                width: "1em"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
                }
              })
            ]
          )
        ]
      )
    ]),
    _vm.isDisplayPrint
      ? _c("div", { staticClass: "setting_btn_print" }, [
          _c(
            "button",
            {
              staticClass: "setting_btn_primary",
              style: {
                color: _vm.colorSetting.mainButtonText,
                backgroundColor: _vm.colorSetting.mainButton,
                border: "1px solid" + _vm.colorSetting.borderColor
              },
              on: {
                click: function($event) {
                  return _vm.printPage()
                }
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "1rem",
                    height: "1rem",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "#ffffff",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                },
                [
                  _c("polyline", { attrs: { points: "6 9 6 2 18 2 18 9" } }),
                  _c("path", {
                    attrs: {
                      d:
                        "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
                    }
                  }),
                  _c("rect", {
                    attrs: { x: "6", y: "14", width: "12", height: "8" }
                  })
                ]
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }